import styled from 'styled-components/macro';
import { grayText } from '../../styles/colors';
import { fontSize } from '../../styles/mixins';
import media from '../../styles/media';

export const TextWrapper = styled.h2`
  display: flex;
  justify-content: center;
  width: 100%;
  align-items: center;
  margin-bottom: 12px;
  font-weight: 400;
  color: ${grayText};
  ${fontSize(16)};
  ${media.desktop`
    ${fontSize(32)};
    margin-bottom: 45px;
  `}
`;

export const InfoWrapper = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  justify-content: center;
  align-items: center;
`;
